import { withProps } from 'recompose';
import { getAuthToken, removeAuthToken, authenticate, isAuthenticated } from './authenticator';

export default withProps(() => ({
  getAuthToken,
  removeAuthToken,
  authenticate,
  isAuthenticated
}));
